import type {
  AttributeResponse,
  PlayerResponse,
  RecStatusResponse,
  RpmPercentResponse,
} from '@on3/api';
import { CommittedStatus } from 'components/RecruitmentStatus/CommittedStatus';
import { PredictionStatus } from 'components/RecruitmentStatus/PredictionStatus';
import { SlimTransferStatus } from 'components/RecruitmentStatus/SlimTransferStatus';

interface IStatusContainerProps {
  /**Status of a players recruitment.*/
  status?: RecStatusResponse;
  /**Player Information */
  player?: PlayerResponse;
  /**A list of Player RPM Predictions*/
  rpm?: RpmPercentResponse[] | null;
  /**Changes predictions to stay horizontal for playerCard on visitList.*/
  isPlayerCard?: boolean;
  sport?: AttributeResponse;
}

export const StatusContainer = ({
  status,
  rpm,
  isPlayerCard,
  player,
  sport,
}: IStatusContainerProps) => {
  const showCommitStatus =
    status &&
    status?.type !== 'None' &&
    status?.type !== 'Decommitted' &&
    !status?.transferredAsset;
  const hasRpms = !!rpm?.length;
  const isTransfer = status?.transferredAsset?.key;
  const showPredictions = !showCommitStatus && hasRpms && !isTransfer;

  return (
    <div>
      {showCommitStatus && (
        <CommittedStatus player={player} sport={sport} status={status} />
      )}

      {showPredictions && (
        <PredictionStatus
          isPlayerCard={isPlayerCard}
          player={player}
          rpm={rpm}
        />
      )}
      {isTransfer && <SlimTransferStatus player={player} status={status} />}
    </div>
  );
};
